import { createStore, applyMiddleware } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";

import thunk from "redux-thunk";
import reducers from "./reducers";

let devtools = composeWithDevTools(applyMiddleware(thunk));

if (process.env.NODE_ENV === "production") {
  devtools = applyMiddleware(thunk);
}

const store = createStore(reducers, devtools);

export default store;
